const local = {
    apiUrl: 'https://admin.test',
    imgUrl: 'https://admin.test',
    sieni: 'http://localhost:4200'
}
const dev = {
    apiUrl: 'https://dev.admin.goalempresas.com',
    imgUrl: 'https://dev.admin.goalempresas.com',
    sieni:  'https://dev.toolbox.goalempresas.com/sieni'
}
const prod = {
    apiUrl: 'https://admin.goalempresas.com',
    imgUrl: 'https://admin.goalempresas.com',
    sieni:  'https://toolbox.goalempresas.com/sieni'
}

/**
 * params local = http://localhost:8000
 * params dev = https://dev.admin.goalempresas.com
 * params prod = https://admin.goalempresas.com
 */
export const production = prod;
export const env = dev;
